import {inject, Injectable} from '@angular/core';
import {lastValueFrom} from 'rxjs';
import {injectMutation, QueryClient} from '@tanstack/angular-query-experimental';
import {PermissionId, UserService} from '../../../../../../api';
import {QueryKey} from '../../../../../constants/query-key';

@Injectable()
export class PermissionCommandService {
  private readonly userService = inject(UserService);
  private readonly queryClient = inject(QueryClient);

  // Replaces the full permission set for a single user (reuses the existing per-user endpoint).
  updateMutation = injectMutation(() => ({
    mutationFn: (request: {userAccountId: string; permissions: PermissionId[]}) =>
      lastValueFrom(this.userService.updatePermissions(request.userAccountId, {permissions: request.permissions})),
    onSuccess: () => {
      this.queryClient.invalidateQueries({queryKey: [QueryKey.PERMISSIONS]});
    },
  }));
}
